'use client';
import { ThemeProvider, useTheme as useNextTheme } from 'next-themes';
// add funcs later
export const useTheme = () => useNextTheme();
export { ThemeProvider };
